import type { EnvType } from './types/env.type';

const getEnv = (key: keyof ImportMetaEnv): string | undefined =>
  window.__RUNTIME_CONFIG__?.[key] ?? import.meta.env[key];

export const config = {
  appVersion: __APP_VERSION__,
  appEnv: getEnv('VITE_APP_ENV') as EnvType,
  apiLoginPath: getEnv('VITE_API_LOGIN_PATH'),
  apiBaseUrl: getEnv('VITE_API_BASE_URL'),
  basePath: getEnv('VITE_BASE_PATH'),
  productFruitsWorkspace: getEnv('VITE_PRODUCT_FRUITS_WORKSPACE'),
  supportUrl: getEnv('VITE_SUPPORT_URL'),
  tracking: {
    enabled: getEnv('VITE_TRACKING_ENABLED') === 'true',
    gtmId: getEnv('VITE_GTM_ID') ?? ''
  }
};
